import CoreInstance from '../CoreInstance';
import { isTeacher } from 'lib/helpers';

interface ICreditCards {
  getAllCreditCards(): any;
  getOneCreditCard(id: number): any;
  postCreditCard(body: any): any;
  deleteCreditCard(id: number): any;
  updateDefaultCreditCard(id: number): any;
}

const getOrganizationToken = () => {
  const organizationToken = localStorage.getItem('account_token');
  const headers = {
    headers: {
      Authorization: `Bearer ${organizationToken}`,
    },
  };

  return headers;
};

const creditCards: ICreditCards = {
  getAllCreditCards: () => CoreInstance.get(
    isTeacher() ?
    '/centers/credit_cards'
    : '/organizations/credit_cards',
    getOrganizationToken()),
  getOneCreditCard: (id: number) => CoreInstance.get(
    isTeacher() ?
    `/centers/credit_cards/${id}`
    : `/organizations/credit_cards/${id}`
  ),
  postCreditCard: body => CoreInstance.post(
    isTeacher() ?
    '/centers/credit_cards'
    : '/organizations/credit_cards',
    body,
    getOrganizationToken()
  ),
  deleteCreditCard: (id: number) => CoreInstance.delete(
    isTeacher() ?
    `/centers/credit_cards/${id}`
    : `/organizations/credit_cards/${id}`,
    getOrganizationToken()
  ),
  updateDefaultCreditCard: (id: number) => CoreInstance.put(
    isTeacher() ?
    `/centers/credit_cards/${id}/set_as_default`
    : `/organizations/credit_cards/${id}/set_as_default`,
    {},
    getOrganizationToken()
  ),
};

export default {
  creditCards,
};
